module.exports = __webpack_public_path__ + "static/rankmath-ae0735746bea68584a78abd20d75fd10.svg";